import './App.css';
import { Game, GamePlayState } from './components/Game';
import { useGameContext, useGameState } from './context/game-context';
import Button from '@mui/material/Button';
import { allGames } from './model/games-database';

function App() {
  const [gameState, setGameState] = useGameState();
  const context = useGameContext();

  function startGame() {
    const description = allGames[gameState.ruleset] ?? allGames['Klondike'];
    context.setupBoard(description);
    setGameState((oldState) => ({
      ...oldState,
      playState: GamePlayState.PLAY
    }));
  }

  function resignGame() {
    setGameState((oldState) => ({
      ...oldState,
      playState: GamePlayState.LOSE
    }));
  }

  function chooseRuleset(ruleset: string) {
    setGameState((oldState) => ({
      ...oldState,
      ruleset: ruleset
    }));
  }

  return (
    <div className="app">
      <header className="app-header">
        <div className="title">
          {/*<span className="strike">Fifty</span> <span className="small">three</span> Solitaires*/}
          Solitaires Demo
        </div>
        <div>
          {gameState.playState === GamePlayState.PLAY ? gameState.ruleset : ''}
        </div>
        {gameState.playState === GamePlayState.PLAY ? <Button variant="contained" onClick={resignGame}>Resign</Button> : undefined}
      </header>
      <Game gameState={gameState} onStartGame={startGame} onChooseRuleset={chooseRuleset}/>
    </div>
  );
}

export default App;
